export default __webpack_public_path__ + "static/50-sitzer-3-306bb00929cea23a1e3c1fa05c0db9a7.jpg";